import BackgroundColourFill from 'app/display/backgrounds/BackgroundColourFill';
import { FONT_TITLE, FONT_COLOUR_LEVEL_WIN, FONT_COLOUR_STROKE } from 'app/constants/AppConstants';
import TapArea from 'app/game/TapArea';
import ButtonSimple from 'app/ui/buttons/ButtonSimple';
import { createTextField } from 'utils/Text';
import Hud from 'app/ui/Hud';

import * as AppTrackingEvents from 'app/constants/AppTrackingEvents';

import { GAME_SFX_APPLE_SELECT, GAME_SFX_ONION_SELECT } from 'app/constants/GameSFX';

class CharacterIntro extends Phaser.State {
  init() {}

  create(game) {
    this.game = game;

    this.background = this.game.make.image(0, 0, 'bg_character_select');
    this.background.anchor.set(0.5, 0.5);
    this.game.add.existing(this.background);

    this.container = this.game.add.group();

    this.createCharacters();
    this.createButton();
    this.createPanel();

    this.game.hud.activate({ id: Hud.WELCOME });

    this.logo = this.game.make.image(0, 0, 'logo_game');
    this.logo.anchor.set(1);
    this.logo.scale.set(0.33);
    this.logo.position.set(this.game.defaultWidth - (this.game.defaultWidth - this.game.width) / 2 - 30, this.game.defaultHeight - 60);
    this.container.addChild(this.logo);

    this.selectedCharacter = '';
    this.btnPlay.visible = false;

    this.selectedCharacterArrow = this.game.make.image(0, 0, 'ui', 'arrow');
    this.selectedCharacterArrow.anchor.set(0.5);

    this.selectedCharacterArrow.visible = false;

    this.game.world.bringToTop(this.container);
    this.game.add.existing(this.selectedCharacterArrow);

    this.game.sounds.playBackgroundMusic();

    game.windowEventController.handleWindowResize();
    game.scale.onSizeChange.add(this.positionContainer, this);
    this.positionContainer();
  }

  createCharacters() {
    this.onion = this.game.make.spine(0, 0, 'onionSelect');
    this.onion.setAnimationByName(0, 'idle', true);
    this.onion.anchor.set(0.5, 1);
    let box = this.game.make.image(0, 0, 'ui', 'arrow');
    box.width = 150;
    box.height = 370;
    box.anchor.set(0.5, 1);
    box.alpha = 0;
    this.onion.addChild(box);
    this.onion.inputEnabled = true;

    this.onion.events.onInputDown.add(this.handleSelectOnion, this);
    this.onion.events.onInputOver.add(this.changeCursorPointer, this);
    this.onion.events.onInputOut.add(this.changeCursorNormal, this);

    this.onion.position.set(this.game.defaultWidth * 0.65, this.game.defaultHeight * 0.9);
    this.game.add.existing(this.onion);

    //
    this.apple = this.game.make.spine(0, 0, 'appleSelect');
    this.apple.setAnimationByName(0, 'idle', true);
    this.apple.anchor.set(0.5, 1);
    this.apple.inputEnabled = true;

    this.apple.events.onInputDown.add(this.handleSelectApple, this);
    this.apple.events.onInputOver.add(this.changeCursorPointer, this);
    this.apple.events.onInputOut.add(this.changeCursorNormal, this);

    this.apple.position.set(this.game.defaultWidth * 0.25, this.game.defaultHeight * 0.9);
    this.game.add.existing(this.apple);
  }

  createButton() {
    // try again button
    this.btnPlay = new ButtonSimple({ game: this.game, id: 'btn_play', skin: 'btn_play' });
    this.btnPlay.x = this.game.defaultWidth * 0.5;
    this.btnPlay.y = this.game.defaultHeight * 0.75;
    this.btnPlay.anchor.set(0.5);

    this.btnPlay.onInputDown.add(this.handlePlayGame, this);
    this.game.add.existing(this.btnPlay);
  }

  createPanel() {
    this.mainCopy = createTextField(this.game, FONT_TITLE, 78, FONT_COLOUR_LEVEL_WIN, 0, 0, {
      align: 'center',
      stroke: FONT_COLOUR_STROKE,
      strokeThickness: 6,
    });
    this.mainCopy.text = this.game.copy.getCopy('character_select');
    this.mainCopy.anchor.set(0.5);
    this.mainCopy.setShadow(3, 3, 'rgba(0,0,0,0.5)', 0);

    this.game.add.existing(this.mainCopy);
  }

  handleSelectOnion() {
    if (this.selectedCharacter !== CharacterIntro.SELECTED_ONION) {
      if (!this.btnPlay.visible) {
        this.btnPlay.visible = true;
        //this.selectedCharacterArrow.visible = true;
      }

      this.selectedCharacter = CharacterIntro.SELECTED_ONION;
      //this.selectedCharacterArrow.position.set(this.onion.x, this.onion.y - this.onion.height * 1.1);

      this.onion.setAnimationByName(0, 'selected', false);
      this.onion.addAnimationByName(0, 'selected_loop', true);
      this.apple.setAnimationByName(0, 'idle', true);

      this.game.sounds.playSFX(GAME_SFX_ONION_SELECT);
    }
  }

  handleSelectApple() {
    if (this.selectedCharacter !== CharacterIntro.SELECTED_APPLE) {
      if (!this.btnPlay.visible) {
        this.btnPlay.visible = true;
        //this.selectedCharacterArrow.visible = true;
      }
      this.selectedCharacter = CharacterIntro.SELECTED_APPLE;
      //this.selectedCharacterArrow.position.set(this.apple.x, this.apple.y - this.apple.height * 1.25);

      this.apple.setAnimationByName(0, 'selected', false);
      this.apple.addAnimationByName(0, 'selected_loop', true);
      this.onion.setAnimationByName(0, 'idle', true);

      this.game.sounds.playSFX(GAME_SFX_APPLE_SELECT);
    }
  }

  handlePlayGame() {
    this.game.controller.gameModel.setChosenCharacter(this.selectedCharacter);

    switch (this.selectedCharacter) {
      case CharacterIntro.SELECTED_APPLE:
        this.game.track(AppTrackingEvents.CHARACTER_SELECT_APPLE);
        break;
      case CharacterIntro.SELECTED_ONION:
        this.game.track(AppTrackingEvents.CHARACTER_SELECT_ONION);
        break;
    }

    this.game.controller.startNewGame();
    // this.game.controller.showGameEnd({ win: true, character: this.selectedCharacter });
  }

  positionContainer() {
    const x = (this.game.width - this.game.defaultWidth) * 0.5;
    const y = 0;

    let scale = Math.max(this.game.height / this.game.defaultHeight, this.game.width / this.game.defaultWidth);
    this.background.scale.set(scale);
    this.background.position.set(this.game.width * 0.5, this.game.height * 0.5);

    let yOffset = 1 - scale;
    yOffset /= 4;

    this.onion.position.set(this.game.width * 0.75, this.game.height * (0.9 - yOffset));
    this.apple.position.set(this.game.width * 0.25, this.game.height * (0.9 - yOffset));

    this.selectedCharacterArrow.position.set(
      this.selectedCharacter == CharacterIntro.SELECTED_APPLE ? this.apple.x : this.onion.x,
      this.selectedCharacter == CharacterIntro.SELECTED_APPLE ? this.apple.y - this.apple.height * 1.25 : this.onion.y - this.onion.height * 1.1
    );

    this.mainCopy.position.set(this.game.width * 0.5, this.game.height * (0.3 + yOffset));

    this.btnPlay.position.set(this.game.width * 0.5, this.game.height * 0.75);

    this.logo.position.set(this.game.defaultWidth - (this.game.defaultWidth - this.game.width) / 2 - 30, this.game.defaultHeight - 60);

    this.container.position.set(x, y);
  }

  changeCursorNormal() {
    this.game.canvas.style.cursor = 'default';
  }

  changeCursorPointer() {
    this.game.canvas.style.cursor = 'pointer';
  }

  shutDown() {
    // remove listeners
    game.scale.onSizeChange.remove(this.positionContainer, this);
    this.apple.events.onInputDown.remove(this.handleSelectApple, this);
    this.onion.events.onInputDown.remove(this.handleSelectOnion, this);

    this.apple.events.onInputOver.remove(this.changeCursorPointer, this);
    this.apple.events.onInputOut.remove(this.changeCursorNormal, this);
    this.onion.events.onInputOver.remove(this.changeCursorPointer, this);
    this.onion.events.onInputOut.remove(this.changeCursorNormal, this);

    //destroy
    this.background.destroy(true);
    this.container.destroy(true);

    this.apple.destroy(true);
    this.onion.destroy(true);
    this.mainCopy.destroy(true);
    this.btnPlay.destroy(true);
    this.logo.destroy(true);

    this.selectedCharacterArrow.destroy(true);

    //nullify
    this.background = null;
    this.container = null;
    this.apple = null;
    this.onion = null;
    this.mainCopy = null;
    this.btnPlay = null;
    this.logo = null;
    this.selectedCharacterArrow = true;
    this.selectedCharacter = null;
  }
}

CharacterIntro.SELECTED_ONION = 'CharacterIntro.SELECTED_ONION';
CharacterIntro.SELECTED_APPLE = 'CharacterIntro.SELECTED_APPLE';

export default CharacterIntro;
